import axios from 'axios'

/**
 *
 * @param {object} payload {topicId,workspaceId,filterOptions...}
 * @returns {array}
 */
export const getAllQuestions = async (payload) => {
  const response = await axios.post(`mcq/list`, payload, {
    checkWorkspaceId: true
  })
  return response
}

/**
 *
 * @param {string} workspaceId and topic Id
 * @returns {array}
 */
export const getAllTagsForQuestion = async (workspaceId, topicId = null) => {
  const response = await axios.get(
    `mcq/tags${workspaceId ? `?workspaceId=${workspaceId}` : ''}${
      topicId
        ? workspaceId
          ? `&topicId=${topicId}`
          : `?topicId=${topicId}`
        : ''
    }`
  )
  return response
}

/**
 *
 * @param {object} payload
 * @returns array of tags according to filter and topicId
 */
export const getFilteredTags = async (payload) => {
  const response = await axios.post(`mcq/list-tags`, payload)
  return response
}

/**
 *
 * @param {string} workspaceId
 * @returns {array}
 */
export const getAllTopicsForQuestion = async (workspaceId) => {
  const response = await axios.get(
    `mcq-topics${workspaceId ? `?workspaceId=${workspaceId}` : ''}`
  )
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const addTopicForQuestion = async (payload) => {
  const response = await axios.post(`mcq-topics`, payload)
  return response
}

/**
 *
 * @param {object} payload
 * @param {string} workspaceId
 * @returns {string} url
 */

export const uploadImageToS3 = async (payload, workspaceId) => {
  const response = await axios.post(
    `mcq/upload-image${workspaceId ? `?workspaceId=${workspaceId}` : ''}`,
    payload,
    {
      headers: { 'content-type': 'multipart/form-data' }
    }
  )
  return response
}

/**
 *
 * @param {object} paylaod
 * @returns
 */
export const addMCQQuestion = async (paylaod) => {
  const response = await axios.post(`mcq`, paylaod)
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const updateMCQQuestion = async (payload) => {
  const response = await axios.put(`mcq?questionId=${payload?.id}`, payload)
  return response
}

/**
 *
 * @param {string} workspaceId
 * @param {object} payload
 * @returns
 */
export const generateMCQQuestions = async (workspaceId, payload) => {
  const response = await axios.post(
    `mcq/generate-questions${workspaceId ? `?workspaceId=${workspaceId}` : ''}`,
    payload
  )
  return response
}

/**
 *
 * @param {object} payload
 */
export const swapAutogeneratedQuestion = async (payload) => {
  const response = await axios.post(`mcq/swap-question`, payload)
  return response
}

/**
 *
 * @param {object} payload
 * @param {string} workspaceId
 * @returns
 */
export const uploadMCQCSV = async (
  payload,
  workspaceId,
  isDevUser = false,
  isLive,
  isOverwrite = false,
  skipQuestions = false
) => {
  const response = await axios.post('mcq/upload', payload, {
    headers: { 'content-type': 'multipart/form-data' },
    params: {
      isLive: isLive,
      workspaceId: !isDevUser ? workspaceId : null,
      overwrite: isOverwrite,
      skipQuestions: skipQuestions
    }
  })
  return response
}

/**
 *
 * @param {object} payload
 * @param {string} workspaceId
 * @param {boolean} isDevUser
 * @returns
 */
export const uploadMCQJSON = async (
  payload,
  workspaceId,
  isDevUser = false,
  isLive,
  isOverwrite = false,
  skipQuestions = false
) => {
  const response = await axios.post('mcq/upload-json', payload, {
    params: {
      isLive: isLive,
      workspaceId: !isDevUser ? workspaceId : null,
      overwrite: isOverwrite,
      skipQuestions: skipQuestions
    }
  })
  return response
}

/**
 *
 * @param {object} payload {id,isLIve,subscriptionPlanIds,mark,difficulty}
 * @returns
 */
export const updateMetaDetails = async (payload) => {
  const response = await axios.put(`mcq/update-meta-details`, payload)
  return response
}

/**
 *
 * @param {string} fileType
 * @returns
 */
export const getSampleFileData = async (fileType) => {
  const response = await axios.get(`mcq/download-sample?fileType=${fileType}`, {
    responseType: 'blob'
  })
  return response
}

/**
 *
 * @param {FormData} file
 * @param {string} workspaceId
 * @returns
 */
export const uploadMettlFile = async (file, workspaceId, isLive) => {
  const response = await axios.post(
    `mcq/import-mettl-file?workspaceId=${workspaceId}&isLive=${isLive}`,
    file,
    {
      headers: { 'content-type': 'multipart/form-data' }
    }
  )
  return response
}

/**
 *
 * @param {object} payload  {workspaceId,approvedQuestions,pendingQuestions}
 * @returns
 */
export const bulkApproveRejectQuestions = async (payload) => {
  const response = await axios.post(`mcq/status-change`, payload)
  return response
}

/**
 *
 * @returns
 */
export const getFeatureLibraryOptions = async () => {
  const response = await axios.get(`features/library`)
  return response
}

export const deleteQuestionBulk = async (payload) => {
  const response = await axios.post('mcq/bulk-delete', payload)
  return response
}

export const softDeleteInformation = async (payload) => {
  const response = await axios.post('mcq/existing-challenges', payload)
  return response
}

export const getPsychometricPreviewQuestion = async (payload) => {
  const response = await axios.get(
    `mcq/psychometric-questions?workspaceId=${payload?.workspaceId}&types=${payload?.types}`
  )
  return response
}
